import type { FC, PropsWithChildren } from "react";
import React, { createContext, useContext, useState } from "react";

interface SubscriptionActionTakenProps {
  wasActionTaken: boolean;
  setAction?: (wasActionTaken: boolean) => void;
}

interface SubscriptionActionTakenHookProps {
  wasActionTaken: boolean;
  setActionTaken: () => void;
  setActionNotTaken: () => void;
}

interface SubscriptionActionTakenProviderProps {
  decisionTakenInitialState?: boolean;
}

const SubscriptionActionTakenContext =
  createContext<SubscriptionActionTakenProps>({
    wasActionTaken: false,
  });

export const SubscriptionActionTakenProvider: FC<
  PropsWithChildren<SubscriptionActionTakenProviderProps>
> = ({ children, decisionTakenInitialState }) => {
  const [wasActionTaken, setAction] = useState(!!decisionTakenInitialState);
  return (
    <SubscriptionActionTakenContext.Provider
      value={{ wasActionTaken, setAction }}
    >
      {children}
    </SubscriptionActionTakenContext.Provider>
  );
};

export const useSubscriptionActionTaken =
  (): SubscriptionActionTakenHookProps => {
    const { wasActionTaken, setAction } = useContext(
      SubscriptionActionTakenContext,
    );
    return {
      wasActionTaken,
      setActionTaken: (): void => setAction && setAction(true),
      setActionNotTaken: (): void => setAction && setAction(false),
    };
  };
